<template>
    <div class="loader">
        <div class="loader-container">
            <img src="https://www.nuskin.com/dam/apps/checkout/spinner.gif" alt="Spinner">
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoginTokenView"
    }
</script>

<style lang="scss" scoped>
    .loader {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background-color: rgba(255, 255, 255, 0.5);
        pointer-events: none;

        .loader-container {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
        }

        img {
            height: 150px;
            width: 150px;
            align-self: center;
        }
    }
</style>
